// @ts-nocheck
// A single "game needing results" row — shared by the Game Results page
// (UpcomingGamesAdmin) and the division page's Enter Results card. Renders the
// matchup + missing-data badges, the basketball per-game "Scan Scoresheet"
// button + "Enter Stats" link to the manual grid, the pickleball/soccer inline
// ManualScoreEntry, and the volleyball per-set SetScoreEntry. Keep this the
// ONE source for the row so both pages stay in sync.
import React from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import helpers from '@/utils/helpers';
import getTeamDisplayName from '@staty/shared/utils/getTeamDisplayName';

import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { BarChart3, Camera, MapPinOff, Users } from 'lucide-react';

import ManualScoreEntry from './ManualScoreEntry';
import SetScoreEntry from './SetScoreEntry';

const teamLabel = (ref) =>
  ref && typeof ref === 'object' ? getTeamDisplayName(ref) : null;

export default function GameResultRow({ game: g, sport, supported, onScanBasketball, onSaved }) {
  const missingTeams = !helpers.getObjId(g.homeTeam) || !helpers.getObjId(g.awayTeam);
  const missingLocation = !helpers.getObjId(g.locationModel) && !g.location;
  const home = teamLabel(g.homeTeam) || g.homeTeamPlaceholder || 'TBD';
  const away = teamLabel(g.awayTeam) || g.awayTeamPlaceholder || 'TBD';
  const loc = g.locationModel?.name || g.location;
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 border rounded-md px-3 py-2">
      <div className="flex flex-col">
        <div className="font-medium">{home} <span className="text-muted-foreground">vs</span> {away}</div>
        <div className="text-xs text-muted-foreground">
          {_.compact([g.time, loc]).join(' · ')}
        </div>
      </div>
      <div className="flex items-center gap-2">
        {missingTeams && (
          <Badge variant="outline" className="bg-warning/10 text-warning border-warning/30">
            <Users className="h-3 w-3 mr-1" /> Missing teams
          </Badge>
        )}
        {missingLocation && (
          <Badge variant="outline" className="bg-warning/10 text-warning border-warning/30">
            <MapPinOff className="h-3 w-3 mr-1" /> Missing location
          </Badge>
        )}
        {supported && sport === 'basketball' && (
          <>
            <Button size="sm" variant="outline"
              disabled={missingTeams}
              onClick={() => onScanBasketball && onScanBasketball(g)}>
              <Camera className="h-4 w-4 mr-2" /> Scan Scoresheet
            </Button>
            {!missingTeams && (
              <Button size="sm" variant="outline" asChild>
                <Link to={`/admin/game/${g._id}/stats`}>
                  <BarChart3 className="h-4 w-4 mr-2" /> Enter Stats
                </Link>
              </Button>
            )}
          </>
        )}
        {(sport === 'pickleball' || sport === 'soccer') && !missingTeams && (
          <ManualScoreEntry game={g} onSaved={onSaved} />
        )}
        {sport === 'volleyball' && !missingTeams && (
          <SetScoreEntry game={g} onSaved={onSaved} />
        )}
      </div>
    </div>
  );
}
